import { Dialog, DialogContent } from '@mui/material';
import './Dialog.css'
import { useEffect, useState } from 'react';


export const DialogTrigger = ({ dialogContent: {component:DialogCustomContent, props:Props}, children, contentStyle, disabled, beforeOpenCallback, onCloseCallback }) => {


  const [open, setOpen] = useState(false);

  const onClose = (e) => {
    e.stopPropagation();
    setOpen(false);
    onCloseCallback?.();
  }

  
  const onOpen = () => {
    if(disabled) return
    setOpen(true)
  }

  useEffect(()=>{
    if (open)  {
      beforeOpenCallback?.();
    }
  },[open])


  return (<>
      <button className='dialog-trigger-component' onClick={() =>  onOpen()}>
        {children}
      </button>
    <Dialog open={open} onClose={onClose} BackdropProps={{ style: { backdropFilter: 'blur(5px)', background: "rgba(0,0,0,0.5)"} }}
      PaperProps={{

        sx: {
          borderRadius: '12px',
          // boxShadow: 'var(--pop-over-shadow)'
          maxWidth: '95vw',
          // padding: '1rem'
          // background: "magenta"
        }

      }}>
      <DialogContent>
        <DialogCustomContent onClose={onClose} {...Props}></DialogCustomContent>
      </DialogContent>
    </Dialog>
  </>
  )

}